export var ClientAppPlatform = /*#__PURE__*/function (ClientAppPlatform) {
  ClientAppPlatform["frontend"] = "frontend";
  ClientAppPlatform["admin"] = "admin";
  return ClientAppPlatform;
}(ClientAppPlatform || {});
;
export var ServerAppPlatform = /*#__PURE__*/function (ServerAppPlatform) {
  ServerAppPlatform["backend"] = "backend";
  return ServerAppPlatform;
}(ServerAppPlatform || {});
;
// "virtual platform" refers to separate feature packages which are currently run as part of another platform.
export var VirtualAppPlatform = /*#__PURE__*/function (VirtualAppPlatform) {
  VirtualAppPlatform["frontendManagement"] = "frontend-management";
  VirtualAppPlatform["backendAdmin"] = "backend-admin";
  return VirtualAppPlatform;
}(VirtualAppPlatform || {});
// ENV_CONFIG_KEY is defined in @core/shared/config/interfaces.ts, build-static-config.sh and bundle-config.webpac-plugin.ts!
export const ENV_CONFIG_KEY = 'runtimeConfig';